<template>
  <v-layout row wrap class="text-courier-new-xs-white layout row">
    <v-flex xs12 md4 class="text-md-left mr-3">
      <h2 class="">
        Address Details
      </h2>
      <div class="mt-3">
        <p class="text-lg text-gray-500">
          {{ currentOutlet.address }}
        </p>
      </div>
    </v-flex>
    <v-flex xs12 md3 class="text-md-left mb-3">
      <h2 class="text-2xl font-extrabold text-gray-900 sm:text-3xl">
        Contacts
      </h2>
      <div class="mt-3">
        <div class="">
          <div class="flex-shrink-0">
            <v-icon small :class="`text-${color}`">phone</v-icon>
            {{ currentOutlet.phone || 'TBA' }}
          </div>
        </div>
        <div class="">
          <a class="link text-link flex-shrink-0" :href="`mailto:${currentOutlet.email}`">
             <v-icon small :class="`text-${color}`">mail</v-icon>
            {{ currentOutlet.email || 'TBA' }}
          </a>
        </div>
         <div class="">
          <a target="_blank" class="link text-link flex-shrink-0" :href="`https://instagram.com/${instagramUsername}`">
             <v-icon small :class="`text-${color}`">fa fa-instagram</v-icon>
            {{ instagramUsername }}
          </a>
        </div>
      </div>
    </v-flex>
    <v-flex xs12 md4 class="text-md-left">
      <h2 class="text-2xl font-extrabold text-gray-900 sm:text-3xl">
        Opening Hours
      </h2>
      <div class="mt-3">
        <p class="wordwrap">
          {{ currentOutlet.opening_hours }}
        </p>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'outlet-address-card',
  props: {
    currentOutlet: {
      type: Object,
      default: () => ({})
    },
    color: {
      type: String,
      default: 'white'
    }
  },
  computed: {
    instagramUsername () {
      return this.currentOutlet.instagram_url
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/OutletAddressCard.vue